import React, { Component } from 'react';

class Rewards extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="rewards">
        <div className="rewards__rewardsContainer">
          <div className="rewards__rewardsContainer__content">
            <div className="rewards__rewardsContainer__header">
              <h3>30-Day Satisfaction Guarantee</h3>
              <p />
              <img src="./assets/satisfaction.png" alt="" />
            </div>
            <h4>
              We want you to feel 100% confident in using our prescription
              services. That is why we offer a 30-day refund policy. <br />{' '}
              <br />
              Here’s how it works:
            </h4>
            <p>
              If you are not satisfied with your purchase for any reason at all
              simply call our customer service representatives at 1-877-768-7230
              within 30 days of delivery* and explain that you are unsatisfied
              with the product. You may also contact us by email at
              info@medsourceinternational.com
            </p>
            <br />
            <p>
              You are entitled to a refund for the unused portion of the
              product(s) you ordered. For example, if you have not used any of
              the medicine, you are entitled to a 100% refund. If you ordered
              100 tablets and used 80 tablets, you are entitled to a refund of
              20% of your order value.
            </p>
            <br />
            <p>
              Your refund will be processed via the same method of payment
              originally used to pay for the purchase. (i.e. If you paid by
              credit card you will receive a credit card refund.)
            </p>
            <br />
            <p>
              Please note that for your safety no products are ever restocked or
              resold.
            </p>
            <br />
            <span>
              IMPORTANT: You must contact us within 30 days of receiving your
              order in order to qualify for a refund as per the terms stated
              above.
            </span>
            <br />
            <br />
            <p>
              Refunds will be processed within 7 business days of the unused
              medication being returned. You should expect to receive your
              refund within four weeks from the time your refund is confirmed.
              However, in many cases you will receive a refund more quickly The
              timing will depend on your bank or credit card company processing
              our refund request. We will notify you via e-mail of your refund
              once your request has been processed by our billing department.
            </p>
            <br />
            <h4>Don't be fooled by other “refund” policies that:</h4>
            <p>
              Offer to refund you 100% of the value of the product. Med Source
              International offers you a refund of 100% of your original
              purchase price. There is a difference.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Rewards;



// WEBPACK FOOTER //
// ./src/components/Satisfaction/Satisfaction.js